import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinBonPreviewComponent extends Component {
  @service store;

  get bonValue() {
    return this.args.bonValue;
  }

  get investmentsValue() {
    const investments = this.args.investments;
    if (!investments) return '-';
    if (
      (investments?.calculations || []).length === 0 &&
      (investments?.value || 0) === 0
    )
      return '-';
    return investments.value;
  }

  get returnsValue() {
    const returns = this.args.returns;
    if (!returns) return '-';
    if (
      (returns?.calculations || []).length === 0 &&
      (returns?.value || 0) === 0
    )
      return '-';
    return returns.value;
  }

  @action
  roleName(role_id) {
    return this.store.peekRecord('role', role_id)?.name;
  }

  @action
  teamName(team_id) {
    return this.store.peekRecord('team', team_id)?.name;
  }

  @action
  multiply(...args) {
    return args.reduce((acc, item) => +item * +acc, 1);
  }
}
